import {IPromoCardSimple} from "@housebets/housebets-x-package";

export const promoList: IPromoCardSimple[] = [
    {
        id: "10",
        image: "/img/promo-home/001-min.webp",
        href: "https://docs.housebets.com/promotions/double-your-1st-deposit",
    },
    {
        id: "7",
        image: "/img/promo-home/004-min.webp",
        href: "https://docs.housebets.com/promotions/weekly-and-monthly-bonuses",
    },

    {
        id: "2",
        image: "/img/promo-home/009-min.webp",
        href: "https://docs.housebets.com/promotions/the-rewards-slider",
    },

    {
        id: "6",
        image: "/img/promo-home/005-min.webp",
        href: "https://docs.housebets.com/promotions/rewards-that-move-you",
    },

    {
        id: "3",
        image: "/img/promo-home/008-min.webp",
        href: "https://docs.housebets.com/promotions/here-comes-rakeback",
    },
    {
        id: "1",
        image: "/img/promo-home/010-min.webp",
        href: "https://docs.housebets.com/promotions/hbts-airdrop",
    },
    // {
    //     id: "4",
    //     image: "/img/promo-home/Property 1=5.webp",
    //     href: "#",
    // },
    // {
    //     id: "5",
    //     image: "/img/promo-home/Property 1=6.webp",
    //     href: "#",
    // },
    // {
    //     id: "8",
    //     image: "/img/promo-home/Property 1=9.webp",
    //     href: "#",
    // },
    // {
    //     id: "9",
    //     image: "/img/promo-home/Property 1=10.webp",
    //     href: "#",
    // },
    // {
    //     id: "11",
    //     image: "/img/promo-home/Property 1=12.webp",
    //     href: "#",
    // },
];
